var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M1 5a2 2 0 0 1 2-2h5.586A2 2 0 0 1 10 3.586L11.414 5H21a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }